import actions from 'constants/reducers';
import { IReducerFn } from '../type';
import { TCheckoutDrawerState } from './checkoutDrawer.types';

export const checkoutDrawer: IReducerFn<TCheckoutDrawerState> = (state, { type }) => {
  switch (type) {
    case actions.checkoutDrawer.set:
      return {
        ...state,
        isOpen: true,
      };
    case actions.checkoutDrawer.close:
      return {
        ...state,
        isOpen: false,
      };
    default:
      return state;
  }
};

checkoutDrawer.key = 'checkoutDrawer';
checkoutDrawer.initialState = {
  product: {
    name: '',
    description: '',
    price: 0,
  },
  isOpen: false,
  isLoading: false,
  isError: false,
  isSuccess: false,
  isAllowed: true,
};
